import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Partnership section for FAQ Page
 */
const Partnership = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="partnership-component"
    >
      <AccordionV2
        testId="launch"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="Why aren't partnerships and sole-proprietorships eligible? Aren't these companies just as enterprising, if not more so?"
            className="px-0 font-medium"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <p className="m-0 px-6 pb-2 pt-4">
          You are absolutely right. We do recognise the enterprising spirit of
          such ventures. However, we wanted to focus on incorporated companies
          as they would have consistent audited financial records. This would
          ensure an equitable comparison amongst the participating companies.
        </p>
      </AccordionV2>
    </div>
  );
};

export default Partnership;
